import { render } from "./BlogPostWrapper.vue?vue&type=template&id=29e6a8fa"
import script from "./BlogPostWrapper.vue?vue&type=script&lang=js"
export * from "./BlogPostWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__